import { commandSlice } from "./reducer";

export const { deleteCommand, replaceCommands, saveCommand } =
  commandSlice.actions;
